webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tether_tooltip__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_tether_tooltip___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_tether_tooltip__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_tabs__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_accordions__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_password_strength_meter__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_radio_group_toggle__ = __webpack_require__(9);








__WEBPACK_IMPORTED_MODULE_0_jquery___default()(function () {
  __WEBPACK_IMPORTED_MODULE_2__modules_tabs__["a" /* default */].init();
  __WEBPACK_IMPORTED_MODULE_3__modules_accordions__["a" /* default */].init();

  var tooltips = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('[data-zva-tooltip]').map(function (index, tooltip) {
    //console.log('tootltip', tooltip);
    return new __WEBPACK_IMPORTED_MODULE_1_tether_tooltip___default.a({
      target: tooltip,
      position: 'bottom right',
      content: __WEBPACK_IMPORTED_MODULE_0_jquery___default()(tooltip).attr('data-zva-tooltip'),
      classes: 'tooltip-theme-zva'
    });
  });

  __WEBPACK_IMPORTED_MODULE_5__modules_radio_group_toggle__["a" /* default */].create({
    observeContext: '.c-zva-registration-content',
    observeInputs: '[name="hat-knr"]',
    valueTargetMap: {
      0: '#hat-knr-nein',
      1: '#hat-knr-ja'
    }
  });

  __WEBPACK_IMPORTED_MODULE_4__modules_password_strength_meter__["a" /* default */].create({
    input: '#password',
    meter: '#password-strength-meter'
  });
});

/***/ }),
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaults = {
  instanceSelector: '[data-tabs]',
  tabSelector: 'data-tab-id',
  panelSelector: 'data-panel-id',
  tabsToggle: '.c-zva-tabs__toggle',
  tabIsActiveClass: 'c-zva-tabs__toggle--is-active',
  tabIsDisabledClass: 'c-zva-tabs__toggle--is-disabled',
  panelIsActiveClass: 'o-panel--is-active'
};

var init = function init(opts) {
  var config = _extends({}, defaults, opts);
  var $instances = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(config.instanceSelector);

  $instances.each(function (index, tab) {
    var $tabs = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(tab);
    $tabs.on('click', config.tabsToggle, function (event) {
      var $clickedTab = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);

      if (!$clickedTab.attr(config.tabSelector)) {
        $clickedTab = $clickedTab.parent();
      }

      if ($clickedTab.hasClass(config.tabIsDisabledClass)) {
        event.preventDefault();
        return false;
      }

      var tabId = $clickedTab.attr(config.tabSelector);
      var $content = $tabs.next(); // assume next element in dom is content
      var $allTabs = $tabs.find('[' + config.tabSelector + ']');
      var $allPanels = $content.find('[' + config.panelSelector + ']');
      var $selectedPanel = $content.find('[' + config.panelSelector + '=' + tabId + ']');

      $allTabs.removeClass(config.tabIsActiveClass);
      $clickedTab.addClass(config.tabIsActiveClass);
      $allPanels.removeClass(config.panelIsActiveClass);
      $selectedPanel.addClass(config.panelIsActiveClass);

      return true;
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaults = {
  exclusive: false,
  instanceAttribute: 'data-accordion',
  instanceSelector: '[data-accordion]',
  accordionToggleSelector: '[data-accordion-toggle]',
  accordionItemClass: '.c-zva-accordion__item',
  accordionItemIsActiveClass: 'c-zva-accordion__item--is-active'
};

var init = function init(opts) {
  var config = _extends({}, defaults, opts);
  var $instances = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(config.instanceSelector);

  $instances.each(function (index, acc) {
    var $acc = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(acc);
    var attrConfig = JSON.parse($acc.attr(config.instanceAttribute));
    var instanceConfig = _extends({}, config, attrConfig);

    $acc.on('click', instanceConfig.accordionToggleSelector, function (event) {
      var $currentToggle = __WEBPACK_IMPORTED_MODULE_0_jquery___default()(event.target);
      var $currentItem = $currentToggle.parent(instanceConfig.accordionItemClass);
      var $allItems = $acc.find(instanceConfig.accordionItemClass);

      if (instanceConfig.exclusive) {
        $allItems.removeClass(instanceConfig.accordionItemIsActiveClass);
        $currentItem.addClass(instanceConfig.accordionItemIsActiveClass);
      } else {
        $currentItem.toggleClass(instanceConfig.accordionItemIsActiveClass);
      }
      return true;
    });
  });
};

/* harmony default export */ __webpack_exports__["a"] = ({
  init: init
});

/***/ }),
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_password_strength__ = __webpack_require__(8);




function create(pwSel, meterSel) {
  var $pw = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#password');
  var $meter = __WEBPACK_IMPORTED_MODULE_0_jquery___default()('#password-strength-meter');

  $pw.on('input', function () {
    var pwText = $pw.val();
    var score = Object(__WEBPACK_IMPORTED_MODULE_1__lib_password_strength__["a" /* default */])(pwText);
    $meter.val(score);
  });

  return $pw;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  create: create
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function scorePassword(pass) {
  var score = 0;
  var letters = {};

  if (!pass) {
    return score;
  }

  // award every unique letter until 5 repetitions

  for (var i = 0; i < pass.length; i += 1) {
    letters[pass[i]] = (letters[pass[i]] || 0) + 1;
    score += 5.0 / letters[pass[i]];
  }

  // bonus points for mixing it up
  var variations = {
    digits: /\d/.test(pass),
    lower: /[a-z]/.test(pass),
    upper: /[A-Z]/.test(pass),
    nonWords: /\W/.test(pass)
  };

  var variationCount = Object.keys(variations).map(function (vari) {
    return variations[vari];
  }).filter(function (vari) {
    return vari;
  }).length;

  score += (variationCount - 1) * 10;

  return parseInt(score, 10);
}

/* harmony default export */ __webpack_exports__["a"] = (scorePassword);

/***/ }),
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jquery__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };



var defaults = {
  exclusive: false
};

var create = function create(opts) {
  var config = _extends({}, defaults, opts);

  var disableAllTargets = function disableAllTargets() {
    Object.values(config.valueTargetMap).forEach(function (target) {
      __WEBPACK_IMPORTED_MODULE_0_jquery___default()(target).hide();
    });
  };

  var selectTarget = function selectTarget(value) {
    var targetSel = config.valueTargetMap[value];
    if (!targetSel) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_0_jquery___default()(targetSel).show();
  };

  var handleInputChange = function handleInputChange(evt) {
    var selectedValue = evt.target.value;
    disableAllTargets();
    selectTarget(selectedValue);
  };

  return __WEBPACK_IMPORTED_MODULE_0_jquery___default()(config.observeContext).on('change', config.observeInputs, handleInputChange);
};

/* harmony default export */ __webpack_exports__["a"] = ({
  create: create
});

/***/ })
],[2]);


// WEBPACK FOOTER //
// build.js